export enum Result {
    MATCH = 'MATCH',
    DENY = 'DENY',
    CHALLENGE = 'CHALLENGE',
    OTHER = 'OTHER'
}